<template>
    <v-container fluid>
        <v-card tile :loading="loading">
            <div class="card-title">{{ $t('LocationManagement') }}</div>

            <v-card-text>
                <v-tabs v-model="activeTab" grow>
                    <v-tab>{{ $t('Region') }}</v-tab>
                    <v-tab>{{ $t('City') }}</v-tab>
                    <v-tab>{{ $t('StreetName') }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="activeTab">
                    <!-- region Tab -->
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" class="text-right" md="4">
                                            <v-autocomplete v-model="selectedMunicipalityForRegion"
                                                            :items="municipalitiesNormalized"
                                                            item-text="name"
                                                            item-value="id"
                                                            :label="$t('FilterByMunicipality')"
                                                            clearable 
                                                            dense @change="loadregions"></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="8" class="text-right">
                                            <v-btn color="primary" class="white--text" @click="openregionDialog()">
                                                <v-icon left>mdi-plus</v-icon>
                                                {{ $t('Add') }} {{ $t('Region') }}
                                            </v-btn>
                                        </v-col>
</v-row>
                                <v-data-table
                                    :headers="regionHeaders"
                                    :items="regions"
                                    :items-per-page="10"
                                    class="elevation-1"
                                >
                                    <template v-slot:[`item.nameAr`]="{ item }">
                                        {{ item.nameAr }}
                                    </template>
                                    <template v-slot:[`item.nameEn`]="{ item }">
                                        {{ item.nameEn || '-' }}
                                    </template>
                                    <template v-slot:[`item.municipalityName`]="{ item }">
                                        {{ item.municipalityName || '-' }}
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <v-icon small class="mr-2" @click="editregion(item)">mdi-pencil</v-icon>
                                        <v-icon small color="error" @click="deleteregion(item.id)">mdi-delete</v-icon>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <!-- city Tab -->
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-autocomplete
                                            v-model="selectedRegionForCity"
                                            :items="regions"
                                            :item-text="language === 'ar' ? 'nameAr' : 'nameEn'"
                                            item-value="id"
                                            :label="$t('FilterByRegion')"
                                            clearable
                                            @change="loadCities"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="8" class="text-right">
                                        <v-btn color="primary" class="white--text" @click="openCityDialog()">
                                            <v-icon left>mdi-plus</v-icon>
                                            {{ $t('Add') }} {{ $t('City') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-data-table
                                    :headers="cityHeaders"
                                    :items="cities"
                                    :items-per-page="10"
                                    class="elevation-1"
                                >
                                    <template v-slot:[`item.nameAr`]="{ item }">
                                        {{ item.nameAr }}
                                    </template>
                                    <template v-slot:[`item.nameEn`]="{ item }">
                                        {{ item.nameEn || '-' }}
                                    </template>
                                    <template v-slot:[`item.regionName`]="{ item }">
                                        {{ item.regionName || '-' }}
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <v-icon small class="mr-2" @click="editCity(item)">mdi-pencil</v-icon>
                                        <v-icon small color="error" @click="deleteCity(item.id)">mdi-delete</v-icon>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <!-- StreetName Tab -->
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-autocomplete
                                            v-model="selectedCityForStreetName"
                                            :items="cities"
                                            :item-text="language === 'ar' ? 'nameAr' : 'nameEn'"
                                            item-value="id"
                                            :label="$t('FilterByCity')"
                                            clearable
                                            @change="loadStreetNames"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="8" class="text-right">
                                        <v-btn color="primary" class="white--text" @click="openStreetNameDialog()">
                                            <v-icon left>mdi-plus</v-icon>
                                            {{ $t('Add') }} {{ $t('StreetName') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-data-table
                                    :headers="streetnameHeaders"
                                    :items="streetnames"
                                    :items-per-page="10"
                                    class="elevation-1"
                                >
                                    <template v-slot:[`item.nameAr`]="{ item }">
                                        {{ item.nameAr }}
                                    </template>
                                    <template v-slot:[`item.nameEn`]="{ item }">
                                        {{ item.nameEn || '-' }}
                                    </template>
                                    <template v-slot:[`item.cityName`]="{ item }">
                                        {{ item.cityName || '-' }}
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <v-icon small class="mr-2" @click="editStreetName(item)">mdi-pencil</v-icon>
                                        <v-icon small color="error" @click="deleteStreetName(item.id)">mdi-delete</v-icon>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>

            <!-- Region Dialog -->
            <CommonDialog v-model="regionDialog" :title="regionDialogTitle" :fullscreen="false" width="600" show-action-toolbar>
                <v-form ref="regionForm" v-model="regionFormValid">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="regionForm.nameAr"
                                    :label="$t('NameAr')"
                                    :rules="[v => !!v || $t('RequiredField')]"
                                    required
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="regionForm.nameEn"
                                    :label="$t('NameEn')"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="regionForm.municipalityId"
                                    :items="municipalitiesNormalized"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('Municipality')"
                                    outlined
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <template v-slot:actions>
                    <v-btn color="primary" class="white--text" @click="saveRegion" :disabled="!regionFormValid">
                        {{ $t('Save') }}
                    </v-btn>
                    <v-btn color="error" class="white--text" @click="regionDialog = false">
                        {{ $t('Cancel') }}
                    </v-btn>
                </template>
            </CommonDialog>

            <!-- city Dialog -->
            <CommonDialog v-model="cityDialog" :title="cityDialogTitle" :fullscreen="false" width="600" show-action-toolbar>
                <v-form ref="cityForm" v-model="cityFormValid">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="cityForm.regionId"
                                    :items="regions"
                                    :item-text="language === 'ar' ? 'nameAr' : 'nameEn'"
                                    item-value="id"
                                    :label="$t('region')"
                                    :rules="[v => !!v || $t('RequiredField')]"
                                    required
                                    outlined
                                    dense
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="cityForm.nameAr"
                                    :label="$t('NameAr')"
                                    :rules="[v => !!v || $t('RequiredField')]"
                                    required
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="cityForm.nameEn"
                                    :label="$t('NameEn')"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <template v-slot:actions>
                    <v-btn color="primary" class="white--text" @click="saveCity" :disabled="!cityFormValid">
                        {{ $t('Save') }}
                    </v-btn>
                    <v-btn color="error" class="white--text" @click="cityDialog = false">
                        {{ $t('Cancel') }}
                    </v-btn>
                </template>
            </CommonDialog>

            <!-- StreetName Dialog -->
            <CommonDialog v-model="streetnameDialog" :title="streetnameDialogTitle" :fullscreen="false" width="600" show-action-toolbar>
                <v-form ref="streetnameForm" v-model="streetnameFormValid">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="streetnameForm.cityId"
                                    :items="cities"
                                    :item-text="language === 'ar' ? 'nameAr' : 'nameEn'"
                                    item-value="id"
                                    :label="$t('City')"
                                    :rules="[v => !!v || $t('RequiredField')]"
                                    required
                                    outlined
                                    dense
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="streetnameForm.nameAr"
                                    :label="$t('NameAr')"
                                    :rules="[v => !!v || $t('RequiredField')]"
                                    required
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="streetnameForm.nameEn"
                                    :label="$t('NameEn')"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <template v-slot:actions>
                    <v-btn color="primary" class="white--text" @click="saveStreetName" :disabled="!streetnameFormValid">
                        {{ $t('Save') }}
                    </v-btn>
                    <v-btn color="error" class="white--text" @click="streetnameDialog = false">
                        {{ $t('Cancel') }}
                    </v-btn>
                </template>
            </CommonDialog>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import LocationService from '@/services/LocationService.js'
import StructuresService from '@/services/StructuresService.js'
    import CommonDialog from '@/components/controls/CommonDialog'

export default {
    components: {
        CommonDialog
    },
    data() {
        return {
            loading: false,
            activeTab: 0,
            language: 'ar',
            regions: [],
            cities: [],
            streetnames: [],
            municipalities: [],
            selectedRegionForCity: null,
            selectedCityForStreetName: null,
            selectedMunicipalityForRegion:null,
            regionDialog: false,
            cityDialog: false,
            streetnameDialog: false,
            regionFormValid: false,
            cityFormValid: false,
            streetnameFormValid: false,
            regionForm: {
                id: null,
                nameAr: '',
                nameEn: '',
                municipalityId: null
            },
            cityForm: {
                id: null,
                regionId: null,
                nameAr: '',
                nameEn: ''
            },
            streetnameForm: {
                id: null,
                cityId: null,
                nameAr: '',
                nameEn: ''
            },
            regionHeaders: [
                { text: this.$t('NameAr'), value: 'nameAr' },
                { text: this.$t('NameEn'), value: 'nameEn' },
                { text: this.$t('Municipality'), value: 'municipalityName' },
                { text: this.$t('Actions'), value: 'actions', sortable: false }
            ],
            cityHeaders: [
                { text: this.$t('NameAr'), value: 'nameAr' },
                { text: this.$t('NameEn'), value: 'nameEn' },
                { text: this.$t('region'), value: 'regionName' },
                { text: this.$t('Actions'), value: 'actions', sortable: false }
            ],
            streetnameHeaders: [
                { text: this.$t('NameAr'), value: 'nameAr' },
                { text: this.$t('NameEn'), value: 'nameEn' },
                { text: this.$t('city'), value: 'cityName' },
                { text: this.$t('Actions'), value: 'actions', sortable: false }
            ]
        }
    },
    computed: {
        ...mapGetters('user', ['language']),
        regionDialogTitle() {
            return this.regionForm.id ? this.$t('Edit') + ' ' + this.$t('Region') : this.$t('Add') + ' ' + this.$t('Region')
        },
        cityDialogTitle() {
            return this.cityForm.id ? this.$t('Edit') + ' ' + this.$t('City') : this.$t('Add') + ' ' + this.$t('City')
        },
        streetnameDialogTitle() {
            return this.streetnameForm.id ? this.$t('Edit') + ' ' + this.$t('StreetName') : this.$t('Add') + ' ' + this.$t('StreetName')
        },
         municipalitiesNormalized() {
            return this.municipalities.map(m => ({
                id: m.id,
                header: null,
                footer: null,
                name: m.name
            }))
        }
    },
    watch: {
        activeTab(newVal) {
            if (newVal === 0) {
                this.loadregions()
            } else if (newVal === 1) {
                this.loadCities()
            } else if (newVal === 2) {
                this.loadStreetNames()
            }
        }
    },
    created() {
        this.loadregions()
        this.loadMunicipalities()
    },
        methods: {
        async loadregions() {
            this.loading = true
            try {
                const response = await LocationService.listRegionsForAdmin(this.selectedMunicipalityForRegion)
                if (response.data) {
                    this.regions = response.data
                }
            } catch (error) {
                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
            } finally {
                this.loading = false
            }
        },
        async loadCities() {
            this.loading = true
            try {
                const response = await LocationService.listCitiesForAdmin(this.selectedRegionForCity)
                if (response.data) {
                    this.cities = response.data
                }
            } catch (error) {
                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
            } finally {
                this.loading = false
            }
        },
        async loadStreetNames() {
            this.loading = true
            try {
                const response = await LocationService.listStreetNamesForAdmin(this.selectedCityForStreetName)
                if (response.data) {
                    this.streetnames = response.data
                }
            } catch (error) {
                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
            } finally {
                this.loading = false
            }
        },
        async loadMunicipalities() {
            try {
                const response = await StructuresService.listMunicipalities()
                if (response.data) {
                    this.municipalities = response.data
                }
            } catch (error) {
                console.error('Error loading municipalities:', error)
            }
        },
        openregionDialog(item = null) {
            if (item) {
                this.regionForm = {
                    id: item.id,
                    nameAr: item.nameAr,
                    nameEn: item.nameEn || '',
                    municipalityId: item.municipalityId
                }
            } else {
                this.regionForm = {
                    id: null,
                    nameAr: '',
                    nameEn: '',
                    municipalityId: null
                }
            }
            this.regionDialog = true
        },
        async saveRegion() {
            if (!this.$refs.regionForm.validate()) return

            this.loading = true
            try {
                if (this.regionForm.id) {
                    await LocationService.updateRegion(this.regionForm.id, this.regionForm)
                } else {
                    await LocationService.createRegion(this.regionForm)
                }
                this.$root.$notification(this.$t('SavedSuccessfully'), 'success')
                this.regionDialog = false
                this.loadregions()
            } catch (error) {
                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
            } finally {
                this.loading = false
            }
        },
        async deleteregion(id) {
            if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                this.loading = true
                try {
                    await LocationService.deleteRegion(id)
                    this.$root.$notification(this.$t('DeletedSuccessfully'), 'success')
                    this.loadregions()
                } catch (error) {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                } finally {
                    this.loading = false
                }
            }
        },
        editregion(item) {
            this.openregionDialog(item)
        },
        openCityDialog(item = null) {
            if (item) {
                this.cityForm = {
                    id: item.id,
                    regionId: item.regionId,
                    nameAr: item.nameAr,
                    nameEn: item.nameEn || ''
                }
            } else {
                this.cityForm = {
                    id: null,
                    regionId: null,
                    nameAr: '',
                    nameEn: ''
                }
            }
            this.cityDialog = true
        },
        async saveCity() {
            if (!this.$refs.cityForm.validate()) return

            this.loading = true
            try {
                if (this.cityForm.id) {
                    await LocationService.updateCity(this.cityForm.id, this.cityForm)
                } else {
                    await LocationService.createCity(this.cityForm)
                }
                this.$root.$notification(this.$t('SavedSuccessfully'), 'success')
                this.cityDialog = false
                this.loadCities()
            } catch (error) {
                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
            } finally {
                this.loading = false
            }
        },
        async deleteCity(id) {
            if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                this.loading = true
                try {
                    await LocationService.deleteCity(id)
                    this.$root.$notification(this.$t('DeletedSuccessfully'), 'success')
                    this.loadCities()
                } catch (error) {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                } finally {
                    this.loading = false
                }
            }
        },
        editCity(item) {
            this.openCityDialog(item)
        },
        openStreetNameDialog(item = null) {
            if (item) {
                this.streetnameForm = {
                    id: item.id,
                    cityId: item.cityId,
                    nameAr: item.nameAr,
                    nameEn: item.nameEn || ''
                }
            } else {
                this.streetnameForm = {
                    id: null,
                    cityId: null,
                    nameAr: '',
                    nameEn: ''
                }
            }
            this.streetnameDialog = true
        },
        async saveStreetName() {
            if (!this.$refs.streetnameForm.validate()) return

            this.loading = true
            try {
                if (this.streetnameForm.id) {
                    await LocationService.updateStreetName(this.streetnameForm.id, this.streetnameForm)
                } else {
                    await LocationService.createStreetName(this.streetnameForm)
                }
                this.$root.$notification(this.$t('SavedSuccessfully'), 'success')
                this.streetnameDialog = false
                this.loadStreetNames()
            } catch (error) {
                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
            } finally {
                this.loading = false
            }
        },
        async deleteStreetName(id) {
            if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                this.loading = true
                try {
                    await LocationService.deleteStreetName(id)
                    this.$root.$notification(this.$t('DeletedSuccessfully'), 'success')
                    this.loadStreetNames()
                } catch (error) {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                } finally {
                    this.loading = false
                }
            }
        },
        editStreetName(item) {
            this.openStreetNameDialog(item)
        }
    }
}
</script>

